import axiosClient from '../utils/API'
import React, {useState, useEffect, useContext} from 'react'
import {useParams, withRouter} from 'react-router-dom'
import API from '../utils/API'
import {Link} from 'react-router-dom'
import Spinner from './Spinner'

import imgdummy from '../assets/banner/SmartTV.png'

import {ContextApp} from '../context/ContextApp'

const ProductDetail = (props) => {
  const [product, setproduct] = useState({})
  const {id} = useParams()

  const contextApp = useContext(ContextApp)
  const {
    getProductById,
    singleProduct,
    singleProductsImages,
    productsRelatedFromOne,
    addProductToCarShopping,
    setCategoryShowClose,
    getProductsBySearch,
    carShopping
  } = contextApp

  const [cantidad, setCantidad] = useState(1)

  useEffect(() => {
    getProductById(id)
    setCategoryShowClose()
  }, [id])


  const [carShoppingHelper, setCarShoppingHelper] = useState([])
  useEffect(() => {
    setCarShoppingHelper(carShopping)
  }, [carShopping])

  const [talla, setTalla] = useState(null)
  const [color, setColor] = useState(null)
  const [disableButton, setDisableButton] = useState(null)

  useEffect(() => {
    if(talla === null || color === null || talla === '0' || color === '0' && typeof(productDetails.color) !== null && typeof(productDetails.size) !== null) {
      setDisableButton(true)
    } else {
      setDisableButton(false)
    }
  }, [talla, color])

  const [disableButtonBySize, setDisableButtonBySize] = useState(null)
  useEffect(() => {
    if(talla === null || talla === '0') {
      setDisableButtonBySize(true)
    } else {
      setDisableButtonBySize(false)
      
    }
  }, [talla])

  const [disableButtonByColor, setDisableButtonByColor] = useState(null)
  useEffect(() => {
    if(color === null || color === '0') {
      setDisableButtonByColor(true)
    } else {
      setDisableButtonByColor(false)
      
    }
  }, [color])

  async function getProductByColorAndSize(id, talla, color) {
    const response = await axiosClient.get('/product-batches', {
      params: {
        "product_id": String(id),
        "size": talla,
        "color": color
      }
    })
    console.log(response.data)
  }

  useEffect(() => {
    if(talla !== null || color !== null) {
      getProductByColorAndSize(singleProduct.id, talla, color)
    }
  }, [talla, color])

  const [imageSelected, setImageSelected] = useState(null)
  
  if (Object.keys(singleProduct).length === 0) {
    return <Spinner />
  }

  console.log(singleProduct);

  const {batches} = singleProduct
  const productDetails = batches[0]

  const {unit_price, regular_price, description} = productDetails

  const handleInput = e => {
    //console.log(e.target.value);
    setCantidad(e.target.value)
  }

  
  const addToCarShopping = () => {
    singleProduct.cantidadCli = Number(cantidad)
    singleProduct.talla = talla
    singleProduct.color = color
  
    addProductToCarShopping(singleProduct)
  }

  const productsRelatedFiltered = productsRelatedFromOne.filter(product => product.batches.length > 0)

  function goToProductsList(singleProuct) {
    props.history.push(`/store/company/${singleProuct.provider.slug}/${singleProuct.provider.id}`)
  }

  return (
    <main id="content" role="main">
      <div class="bg-gray-13 bg-md-transparent">
        <div class="container">
          <div class="my-md-3">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb ">
                <li class="breadcrumb-item ">
                  <a href="../index.html">Home</a>
                </li>
                <span></span>
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
                <span></span>
                <li class="breadcrumb-item active" aria-current="page">
                  Detalle del producto
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      {Object.keys(productDetails).length === 0 ? (
        <Spinner />
      ) : (
        <div class="container">
          <div class="mb-14">
            <div class="row">
              <div class="col-md-6 col-lg-4 col-xl-5 mb-4 mb-md-0">
                <div></div>

                <div class="js-slick-carousel u-slick u-slick--slider-syncing u-slick--slider-syncing-size u-slick--gutters-1 u-slick--transform-off">
                  <div>
                    <a data-fancybox href={imageSelected ? imageSelected : singleProduct.image_url}>
                      <img src={imageSelected ? imageSelected : singleProduct.image_url + '?q240x160'} />
                    </a>
                  </div>
                  <div className="carousel-images-related">
                    {singleProductsImages.map(image => (
                      <div className="carousel-images-related-image">
                        <img src={image} onClick={() => setImageSelected(image)} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-4 mb-md-6 mb-lg-0">
                <div class="mb-2">
                  <a
                    href={`/products/provider/${singleProduct.provider.id}`}
                    class="font-size-12 text-gray-5 mb-2 d-inline-block"
                  >
                    {singleProduct.provider?.name}
                  </a>
                  <h2 class="font-size-25 text-lh-1dot2">
                    {singleProduct.name}
                  </h2>

                  <p>{singleProduct.description}</p>
                  <p>
                    <strong>SKU</strong>: {singleProduct.batches[0].sku || ''}
                  </p>
                </div>
              </div>
              <div class="mx-md-auto mx-lg-0 col-md-6 col-lg-4 col-xl-3">
                <div class="mb-2">
                  <div class="card p-5 border-width-2 border-color-1 borders-radius-17">
                    {singleProduct.batches[0].stock > 0 ? (
                      <div class="text-gray-9 font-size-14 pb-2 border-color-1 border-bottom mb-3">
                        Disponibles en stock:{' '}
                        <span class="text-green font-weight-bold">
                          {singleProduct.batches[0].stock}
                        </span>
                      </div>
                    ) : (
                      <span class="text-red font-size-22 font-weight-bold">
                        Agotado
                      </span>
                    )}

                    <div class="mb-3">
                      <div class="font-size-36">
                        {singleProduct.campaing?.active == 1 ? (
                          singleProduct.campaing?.campaign_feature_id == 3 ? (
                            singleProduct.campaing?.isdelivery == 0 ? (
                              <ins class="font-size-36 text-decoration-none">
                                {' '}
                                {`$${(
                                  singleProduct.batches[0].regular_price -
                                  singleProduct.batches[0].regular_price *
                                    (singleProduct.campaing?.discount / 100)
                                ).toFixed(2)}`}
                              </ins>
                            ) : singleProduct.batches[0]?.regular_price !=
                              singleProduct.batches[0]?.unit_price ? (
                              <ins class="font-size-36 text-decoration-none">
                                {' '}
                                {`$${singleProduct?.batches[0]?.unit_price}`}
                              </ins>
                            ) : (
                              <ins class="font-size-36 text-decoration-none">
                                {' '}
                                {`$${singleProduct?.batches[0]?.unit_price}`}
                              </ins>
                            )
                          ) : singleProduct.batches[0]?.regular_price !=
                            singleProduct.batches[0]?.unit_price ? (
                            <ins class="font-size-36 text-decoration-none">
                              {' '}
                              {`$${singleProduct?.batches[0]?.unit_price}`}
                            </ins>
                          ) : (
                            <ins class="font-size-36 text-decoration-none">
                              {' '}
                              {`$${singleProduct?.batches[0]?.unit_price}`}
                            </ins>
                          )
                        ) : singleProduct.batches[0]?.regular_price !=
                          singleProduct.batches[0]?.unit_price ? (
                          <ins class="font-size-36 text-decoration-none">
                            {' '}
                            {`$${singleProduct?.batches[0]?.unit_price}`}
                          </ins>
                        ) : (
                          <ins class="font-size-36 text-decoration-none">
                            {' '}
                            {`$${singleProduct.promo_price ? singleProduct.promo_price : singleProduct?.batches[0]?.unit_price}`}
                          </ins>
                        )}
                        <del class="font-size-20 ml-2 text-gray-6">
                          {singleProduct.batches[0]?.regular_price !=
                          singleProduct.batches[0]?.unit_price
                            ? '$' + singleProduct.batches[0]?.regular_price
                            : ''}
                        </del>
                        {singleProduct.promo_price ? (
                          <div className="promo_price_exists">
                            <strong>${singleProduct?.unit_price}</strong>
                            <div><span>Descuento del {singleProduct?.active_campaign.discount_percentage}%</span></div>
                          </div>
                        ) :null}
                        
                      </div>
                      {singleProduct.active_campaign ? (
                        <span className="campaing-name-unik">{singleProduct.active_campaign.name}</span>
                      ): null}
                    </div>
                    {singleProduct.batches[0].stock > 0 ? (
                      <div class="mb-3">
                        <h6 class="font-size-14">Cantidad</h6>

                        <div class="border rounded-pill py-1 w-md-60 height-35 px-3 border-color-1">
                          <div class="js-quantity row align-items-center">
                            <div class="col">
                              <input
                                class="js-result form-control h-auto border-0 rounded p-0 shadow-none"
                                id="cantidadP"
                                name="cantidadP"
                                onChange={e => {
                                  handleInput(e)
                  
                                }}
                                type="number"
                                min="1"
                
                                max="100"
                                placeholder="1"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {singleProduct.batches[0].color === null ||
                    singleProduct.batches[0].color === '' ? null : singleProduct
                        .batches[0].stock > 0 ? (
                      <div class="mb-3">
                        <div>
                          <h6 class="font-size-14">Color</h6>
                          <select
                            class=" border rounded-pill py-1 w-md-90 height-35 px-3 border-color-1 js-select dropdown-select btn-block col-12 px-0"
                            data-style="btn-sm bg-white font-weight-normal py-2 border"
                            onChange={(event) => setColor(event.target.value)}
                          >
                            <option value="0" selected>
                              Seleccione Color
                            </option>
                            {singleProduct.batches.map(batche => (
                              <option value={batche.color}>{batche.color}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    ) : null}

                    {singleProduct.batches[0].size === null ||
                    singleProduct.batches[0].size === '' ? null : singleProduct
                        .batches[0].stock > 0 ? (
                      <div class="mb-3">
                        <div>
                          <h6 class="font-size-14">Talla</h6>
                          <select
                            class="border rounded-pill py-1 w-md-90 height-35 px-3 border-color-1  js-select dropdown-select btn-block col-12 px-0"
                            data-style="btn-sm bg-white font-weight-normal py-2 border"
                            onChange={(event) => setTalla(event.target.value)}
                          >
                            <option value="0" selected>
                              Seleccione Talla
                            </option>
                            {singleProduct.batches.map(batche => (
                              <option value={batche.size}>{batche.size}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    ) : null}

                    {singleProduct.batches[0].stock > 0 ? (
                      <div class="mb-2 pb-0dot5">
                        {productDetails.size !== null && productDetails.color !== null ? (
                          <button
                          href="#"
                          class="btn btn-block btn-primary-dark buy product single"
                          onClick={() => addToCarShopping()}
                          disabled={disableButton}
                        >
                          <i class="ec ec-add-to-cart mr-2 font-size-20"></i>{' '}
                          Agregar al carrito
                        </button>
                        ) : productDetails.size !== null && productDetails.color === null ? (
                          <button
                            href="#"
                            class="btn btn-block btn-primary-dark buy product single"
                            onClick={() => addToCarShopping()}
                            disabled={disableButtonBySize}
                          >
                            <i class="ec ec-add-to-cart mr-2 font-size-20"></i>{' '}
                            Agregar al carrito
                          </button>
                        ) : productDetails.size === null && productDetails.color !== null ? (
                          <button
                            href="#"
                            class="btn btn-block btn-primary-dark buy product single"
                            onClick={() => addToCarShopping()}
                            disabled={disableButtonByColor}
                          >
                            <i class="ec ec-add-to-cart mr-2 font-size-20"></i>{' '}
                            Agregar al carrito
                          </button>
                        ) : (
                          <button
                          href="#"
                          class="btn btn-block btn-primary-dark"
                          onClick={() => addToCarShopping()}
                        >
                          <i class="ec ec-add-to-cart mr-2 font-size-20"></i>{' '}
                          Agregar al carrito
                        </button>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-7 pt-6 pb-3 mb-6">
            <div class="container">
              <div class="js-scroll-nav">
                <div class="bg-white pt-4 pb-6 px-xl-11 px-md-5 px-4 mb-6">
                  <div id="Accessories" class="mx-md-2">
                    <div class="position-relative mb-6">
                      <ul class="nav nav-classic nav-tab nav-tab-lg justify-content-xl-center flex-nowrap flex-xl-wrap overflow-auto overflow-xl-visble border-lg-down-bottom-0 pb-1 pb-xl-0 mb-n1 mb-xl-0">
                        <li class="nav-item flex-shrink-0 flex-xl-shrink-1 z-index-2">
                          <a class="nav-link active" href="#Accessories">
                            <div class="d-md-flex justify-content-md-center align-items-md-center">
                              Descripción
                            </div>
                          </a>
                        </li>
                      </ul>
                      <p
                        style={{
                          fontSize: '1.3rem',
                          margin: '1rem',
                        }}
                      >
                        {description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            <div className="products-related-list-main">
                <div className="products-related-list-main-title">
                  <h2>Más Artículos para explorar</h2>
                </div>
                <div className="products-related-list-main-content">
                  {productsRelatedFiltered.slice(0,6).map((product) => {
                    return (
                      <div className="products-related-list-main-item-card">
                        <div className="item-card-head-product">
                        <Link
                             to={`/store/company/${product.batches[0].provider.slug}/${product.batches[0].provider.id}`}
                            class="font-size-12 text-gray-5"
                          >
                            {product.batches[0].provider.name}
                          </Link>
                          <span>
                          <Link
                              to={{
                                pathname: `/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`,
                                state: product.slug
                              }}
                              class="text-blue font-weight-bold"
                            >
                            {product.name}
                          </Link>
                          </span>
                        </div>
                        <div className="item-card-head-product-image">
                        <Link
                              to={{
                                pathname: `/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`,
                                state: product.slug
                              }}
                              class="text-blue font-weight-bold"
                            >
                          <img src={product.image_url} alt="" />
                          </Link>
                        </div>
                        <div className="item-card-head-product-footer">
                          {/* <span>$52,00</span> */}
                          <strong>${product.batches[0].regular_price}</strong>
                        </div>
                      </div>
                    )
                  })}
                  <div className="products-related-list-main-item-look-others">
                      <div className="others-products-info">
                        <h2>Descubre más productos</h2>
                        <span>Relacionados a</span>
                        <strong>{singleProduct.name}</strong>
                      </div>
                      <a href="#" onClick={() => goToProductsList(singleProduct)}><span>&rarr;</span></a>
                  </div>
                </div>
            </div>
            </div>
          </div>
        </div>
      )}
    </main>
  )
}

export default withRouter(ProductDetail)